import React from 'react';
import { IconContext } from 'react-icons';
import { IoIosCloudDownload } from 'react-icons/io';

export const DownloadIcon = ({ styles }) => {
  return (
    <IconContext.Provider value={{ style: { ...styles } }}>
      <div>
        <IoIosCloudDownload />
      </div>
    </IconContext.Provider>
  );
};
